<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GQRtbC/tc-custom/9781442450844.jpg?1730533613522" alt="This image is the cover for the book Hero for WondLa, WondLa"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hero for WondLa, WondLa
      </h1>
      <p class="bookDescription body article font2">
        <b>Celebrate the 10th anniversary of Tony DiTerlizzi’s <i>New York Times</i> bestselling, richly illustrated The Search for Wondla series with this second installment of the modern classic space-age adventure featuring an all-new look.</b><br/><br/>Eva Nine thinks she has everything she’s ever dreamed of when her new friend, human boy Hailey, brings Eva and her friends to the colony of New Attica, where humans of all shapes and sizes live in apparent peace and harmony. But all is not as idyllic as it seems, and Eva Nine soon realizes that something sinister is going on—and if she doesn’t stop it, it could mean the end of everything and everyone on planet Orbona.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tony DiTerlizzi
      </h2>
      
      <p class="authorDescription body article">#1&#160;<I>New York Times</I>&#160;bestselling author and illustrator Tony DiTerlizzi has been creating children&rsquo;s books for over twenty years. From fanciful picture books like&#160;<I>The Spider &amp; the Fly</I>&#160;to chapter book series like the Search for WondLa, DiTerlizzi imbues his stories with a rich imagination. With Holly Black, he created the middle grade series the Spiderwick Chronicles, which has sold 20 million copies, been adapted into a feature film, and been translated in over thirty countries. The Norman Rockwell Museum&rsquo;s exhibition &ldquo;Never Abandon Imagination&rdquo; featured artwork from the beginning of DiTerlizzi&rsquo;s career as a contributing artist for Dungeons &amp; Dragons and broke attendance records. He has been featured in&#160;<I>Time</I>&#160;magazine and&#160;<I>USA TODAY</I>&#160;and on CNN, PBS, NPR, the BBC, and the&#160;<I>Today</I>&#160;show.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      S&S Books for Young Readers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e1fd022e